import { render, staticRenderFns } from "./AdditionalField.vue?vue&type=template&id=082c1106&scoped=true"
import script from "./AdditionalField.vue?vue&type=script&lang=js"
export * from "./AdditionalField.vue?vue&type=script&lang=js"
import style0 from "./AdditionalField.vue?vue&type=style&index=0&id=082c1106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082c1106",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
